import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app.js'
import groupSeries from './group-series'
import workingHoursRules from './working-hours-rules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    workingHoursRules,
    groupSeries,
    app,
  }
})
